export default __webpack_public_path__ + "static/media/AAPlan_Logo.a59d4abc.png";